import { FC } from 'react';

import { Header as HeaderComponent } from '../../components/Header';
import { ShowCoworkingOperatorPhoneButton } from '../../components/ShowCoworkingOperatorPhoneButton';

import { IHeaderProps } from './types';

export const Header: FC<IHeaderProps> = ({ isFixed, coworkingName }) => (
  <HeaderComponent
    call={<ShowCoworkingOperatorPhoneButton />}
    callback={<div />}
    favorite={<div />}
    isFixed={isFixed}
    name={coworkingName}
  />
);

Header.displayName = 'Header';
